enum Actions {
  SAVE_SETTINGS = 'saveSettings',
  UPDATE_SETTINGS_STATE = 'updateSettingsState',
  GET_SETTINGS = 'getSettings',
}

export default Actions;
